(() => {
    const userInterestElement = document.getElementById("user-interest")
    if (userInterestElement) {
        if ("requestIdleCallback" in window) {
            requestIdleCallback(initUserInterestApp)
        } else {
            setTimeout(initUserInterestApp, 1000)
        }
    }

    async function initUserInterestApp() {
        const [{createApp}, UserInterest] = await Promise.all([
            import("vue"),
            import("@/components/Frontend/UserInterest.vue")
        ])

        const app = createApp({})
        app.component("user-interest", UserInterest.default)
        app.mount("#user-interest")
    }
})()
